import { useFormikContext } from 'formik'
import { useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'

import { MobileBottomLayout } from 'src/components'
import { Buttons } from './buttons.component'
import { useAddDraftScan } from 'src/hooks'
import { joinAbsRoute } from 'src/common/utils'
import { ECreateScanMode, IScanCreateForm } from 'src/types'
import { ProceedVerifyModal } from './proceed-verify-modal.component'
import { useScanRelationContext } from '../form-wrapper/relations-context.component'
import { ROUTES } from 'src/constants'

import { useStyles } from './styles'

export const BottomActions = () => {
  const { mutateAsync: addDraftScan } = useAddDraftScan()
  const [verifyOpen, setVerifyOpen] = useState(false)
  const [isDraftSubmitting, setDraftSubmitting] = useState(false)
  const { setStep, step, formType, createScanMode } = useScanRelationContext()
  const { values, submitForm, errors, isSubmitting, dirty } = useFormikContext<IScanCreateForm>()
  const classes = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const { accountId } = useParams()
  const navigate = useNavigate()

  if (step === null) {
    return null
  }

  const handleVerifyOpen = () => {
    setVerifyOpen(true)
  }

  const handleVerifyClose = () => {
    setVerifyOpen(false)
  }

  const handlePrev = () => {
    if (step === 0) {
      navigate(joinAbsRoute(ROUTES.ACCOUNTS, accountId, ROUTES.SCANS_DASHBOARD))
      setStep(null)
      return
    }

    if (step === null) {
      return setStep(0)
    }

    if (createScanMode === ECreateScanMode.AccountImpact && step === 3) {
      setStep(1)
      return
    }

    setStep(step - 1)
  }

  const handleNext = async () => {
    if (step === 3) {
      handleVerifyOpen()
      return
    }

    if (step === null) {
      return
    }

    setStep(step + 1)
  }

  const handleDraft = async () => {
    setDraftSubmitting(true)
    await addDraftScan({ ...values, record_type: formType })
    setDraftSubmitting(false)
  }

  const handleSubmit = async () => {
    await submitForm()
    handleVerifyClose()
  }

  const canProceed = (step === 3 && !Object.keys(errors).length) || false
  const proceedShown = step === 3

  return (
    <>
      {isTablet ? (
        <MobileBottomLayout isFixed>
          <Buttons
            proceedShown={proceedShown}
            handleDraft={handleDraft}
            draftDisabled={!dirty || isDraftSubmitting}
            draftLoading={isDraftSubmitting}
            step={step}
            canProceed={canProceed}
            handleDiscard={handlePrev}
            handleNext={handleNext}
            size="small"
          />
        </MobileBottomLayout>
      ) : (
        <div className={classes.wrapper}>
          <Buttons
            proceedShown={proceedShown}
            handleDraft={handleDraft}
            draftDisabled={!dirty || isDraftSubmitting}
            draftLoading={isDraftSubmitting}
            step={step}
            canProceed={canProceed}
            handleDiscard={handlePrev}
            handleNext={handleNext}
          />
        </div>
      )}
      <ProceedVerifyModal
        isProceeding={isSubmitting}
        handleProceed={handleSubmit}
        open={verifyOpen}
        handleClose={handleVerifyClose}
      />
    </>
  )
}
